module.exports = __webpack_public_path__ + "static/media/kraken-sushi-bar-logo-identidade-visual-768x591.b3a4fb87.jpg";